<div class="container-fluid p-0 m-0">
  <div class="card border-0 p-0 m-0">
    <div class="card-header">
      <span
        (click)="closeDialog()"
        class="material-symbols-outlined float-right text-white"
      >
        close
      </span>
      <span style="font-size: 15px">Set Button Value</span>
    </div>
    <div class="card-body p-1 overflow-auto">
      <div class="m-2">
        <a
          class="btn btn-game"
          [class.btn-game-active]="is_sport"
          (click)="changeTab()"
          >Game Buttons</a
        >
        <a
          class="btn btn-game"
          [class.btn-game-active]="is_casino"
          (click)="changeTab()"
          >Casino Buttons</a
        >
      </div>
      <div *ngIf="buttonData.length > 0 && is_sport">
        <form #formDataForm="ngForm" (submit)="onSubmit()">
          <table class="table">
            <thead>
              <tr>
                <th>Price Label</th>
                <th>Price Value</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let value of buttonData"
                ngModelGroup="buttonFormGroup_{{ value.button_id }}"
              >
                <td>
                  <input
                    type="hidden"
                    name="button_id"
                    [ngModel]="value.button_id"
                  />
                  <input type="hidden" name="type" [ngModel]="value.type" />
                  <input
                    type="text"
                    name="price_label"
                    [(ngModel)]="value.price_label"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    name="price_value"
                    [(ngModel)]="value.price_value"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div class="w-100">
            <button
              style="background: #126e51"
              class="btn btn-block btn-success w-100"
              type="submit"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
      <!-- casino buttons -->
      <div *ngIf="casinoButtonData.length > 0 && is_casino">
        <form #CasinoformDataForm="ngForm" (submit)="onCasinoSubmit()">
          <table class="table">
            <thead>
              <tr>
                <th>Price Label</th>
                <th>Price Value</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let value of casinoButtonData"
                ngModelGroup="buttonFormGroup_{{ value.button_id }}"
              >
                <td>
                  <input
                    type="hidden"
                    name="button_id"
                    [ngModel]="value.button_id"
                  />
                  <input type="hidden" name="type" [ngModel]="value.type" />
                  <input
                    type="text"
                    name="price_label"
                    [(ngModel)]="value.price_label"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    name="price_value"
                    [(ngModel)]="value.price_value"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div class="w-100">
            <button
              style="background: #126e51"
              class="btn btn-block btn-success w-100"
              type="submit"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>

    <div class="card-body p-1 overflow-auto"></div>
  </div>
</div>
